<div [class]="'flex justify-content-evenly ' + (class ?? '')">
    @for (_ of dummyList; track _; let i = $index) {
        <input
            [disabled]="disabled"
            pInputText
            pKeyFilter="num"
            (keyup)="onDigitInput(i, $event)"
            (keydown)="cancelArrowInput($event)"
            (paste)="handlePaste($event)"
            maxlength="1"
            [value]="numbers[i]"
            class="w-3rem text-center" />
    }
</div>
